<template>
  <el-button style="margin-right:10px" type="success" @click="fpxfShow()" size="mini" plain>发票更新（可更新出之前发票）</el-button>
  <el-dialog
    v-model="dialogFormVisible"
    title="发票更新"
    width="30%"
    :before-close="handleClose"
  >

    <el-form :model="temp">
      <el-form-item label="发票类型代码：" :label-width="formLabelWidth">
        <invoice-type v-model:code="temp.fplxdm"  style="width:200px"></invoice-type>
      </el-form-item>
      <el-form-item label="起始日期：" :label-width="formLabelWidth">
        <el-date-picker
          style="width:200px;"
          size="mini"
          value-format="YYYYMMDD"
          v-model="temp.qsrq"
          type="date"
          placeholder="起始日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="终止日期：" :label-width="formLabelWidth">
        <el-date-picker
          style="width:200px;"
          size="mini"
          value-format="YYYYMMDD"
          v-model="temp.zzrq"
          type="date"
          placeholder="终止日期"
        >
        </el-date-picker>
      </el-form-item>

    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="updateFpxf">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>

import { updateInvoice } from "@/api/ea";
export default {
  props: {
    
  },
  data () {
    return {
      formLabelWidth: "120px",
      dialogFormVisible: false,
      temp: {
        comId: this.$store.getters['user/comInfo'].id*1,
        fplxdm: '',
        qsrq: '',
        zzrq: '',
      },
    }
  },
  created () {
    
  },
  methods: {
    fpxfShow(){
      this.dialogFormVisible = true
    },
    updateFpxf(){
      if(this.temp.fplxdm == ""){
        this.$qzfMessage("请选择发票类型代码", 1)
        return
      }
      if(this.temp.qsrq == ""){
        this.$qzfMessage("请选择起始日期", 1)
        return
      }
      if(this.temp.zzrq == ""){
        this.$qzfMessage("请选择终止日期", 1)
        return
      }
      console.log(this.temp)
      updateInvoice(this.temp).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("更新成功")
          this.$emit("success")
          this.dialogFormVisible = false
        }
      })
    },
  }
}
</script>